var map = {
	"./bell.svg": 202,
	"./bondhushava.svg": 203,
	"./bookmark-outline.svg": 204,
	"./close.svg": 205,
	"./comments-outline.svg": 206,
	"./envelope.svg": 207,
	"./fb-blue.svg": 208,
	"./fb-whitebg.svg": 209,
	"./fb.svg": 210,
	"./gallery-whitebg.svg": 211,
	"./google-play.svg": 212,
	"./protichinta.svg": 213,
	"./search.svg": 214,
	"./twitter-whitebg.svg": 215,
	"./video-whitebg.svg": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;